import ProductMotoIns from './ProductMotoIns';
export default ProductMotoIns;
